import { MdOutlineBuild } from 'react-icons/md';
import styled from 'styled-components';

import BaseTitle from 'components/Title';
import { COLOR } from 'styles/styledComponents/color.model';

export const Container = styled.div`
  text-align: center;
  margin-top: 10vh;
`;

export const Title = styled(BaseTitle)`
  text-transform: initial !important;
  color: ${COLOR.OUTER_SPACE}!important;
`;

export const BuildIcon = styled(MdOutlineBuild)`
  font-size: 60px;
  color: ${COLOR.LAVENDER_GRAY};
`;
